// extracted by mini-css-extract-plugin
export default {"app-market-page":"_18ikbax","appMarketPage":"_18ikbax","app-market-page-background-color":"_1n2rva0","appMarketPageBackgroundColor":"_1n2rva0","header":"_keqlc8"};